import React from 'react';
import { Link } from 'react-router-dom';
import config from '../../config';

class SeatActionSuccess extends React.Component {
  render() {
    var action = this.props.action;
    var reservationNumber = this.props.reservationNumber;
    var details = {};
    try { details = JSON.parse(decodeURIComponent(this.props.details || '{}')); } catch (e) { details = {}; }

    var title = 'Success';
    var items = [];
    var financialNote = null;

    if (action === 'switchSeat') {
      title = "Seats Switched Successfully";
      var netDiff = 0;
      (details.switches || []).forEach(function(s) { netDiff += s.diff || 0; });
      items.push(
        <div key="price-breakdown">
          <p style={{margin: '0 0 8px', fontSize: '14px', fontWeight: 'bold'}}>Seat Switch Breakdown</p>
          {(details.switches || []).map(function(s, i) {
            var diff = s.diff || 0;
            var diffLabel = diff > 0 ? '+$' + diff.toFixed(2) : diff < 0 ? '-$' + Math.abs(diff).toFixed(2) : '$0.00';
            var diffColor = diff > 0 ? '#e8512f' : diff < 0 ? '#4CAF50' : '#666';
            return (
              <div key={i} style={{display: 'flex', justifyContent: 'space-between', margin: '0 0 4px', fontSize: '14px'}}>
                <span>Seat <strong>{s.oldSeat}</strong> &rarr; <strong>{s.newSeat}</strong></span>
                <span style={{color: diffColor}}>{diffLabel}</span>
              </div>
            );
          })}
          {(details.switches || []).length > 1 && (
            <div style={{display: 'flex', justifyContent: 'space-between', margin: '8px 0 0', paddingTop: '6px', borderTop: '1px solid #c8e6c9', fontSize: '14px', fontWeight: 'bold'}}>
              <span>Net Total</span>
              <span style={{color: netDiff > 0 ? '#e8512f' : netDiff < 0 ? '#4CAF50' : '#666'}}>
                {netDiff > 0 ? '+$' + netDiff.toFixed(2) : netDiff < 0 ? '-$' + Math.abs(netDiff).toFixed(2) : '$0.00'}
              </span>
            </div>
          )}
        </div>
      );
      var switchCharged = typeof details.totalCharged === 'number' ? details.totalCharged : (netDiff > 0 ? netDiff : 0);
      var switchCredited = typeof details.totalCredited === 'number' ? details.totalCredited : (netDiff < 0 ? Math.abs(netDiff) : 0);
      if (switchCharged > 0) {
        financialNote = <p style={{margin: '4px 0', fontSize: '14px'}}>Total charged: <strong style={{color: '#e8512f'}}>${switchCharged.toFixed(2)}</strong></p>;
      } else if (switchCredited > 0) {
        financialNote = <p style={{margin: '4px 0', fontSize: '14px'}}><strong style={{color: '#4CAF50'}}>${switchCredited.toFixed(2)}</strong> has been added to your credit balance.</p>;
      } else {
        financialNote = <p style={{margin: '4px 0', fontSize: '14px', color: '#666'}}>No additional charges.</p>;
      }
    } else if (action === 'addSeat') {
      title = "Seats Selected Successfully";
      var totalAddon = 0;
      (details.switches || []).forEach(function(s) { totalAddon += s.diff || 0; });
      items.push(
        <div key="price-breakdown">
          <p style={{margin: '0 0 8px', fontSize: '14px', fontWeight: 'bold'}}>Seat Selection Breakdown</p>
          {(details.switches || []).map(function(s, i) {
            return (
              <div key={i} style={{display: 'flex', justifyContent: 'space-between', margin: '0 0 4px', fontSize: '14px'}}>
                <span>Seat <strong>{s.newSeat}</strong></span>
                <span>${(s.diff || 0).toFixed(2)}</span>
              </div>
            );
          })}
          {(details.switches || []).length > 1 && (
            <div style={{display: 'flex', justifyContent: 'space-between', margin: '8px 0 0', paddingTop: '6px', borderTop: '1px solid #c8e6c9', fontSize: '14px', fontWeight: 'bold'}}>
              <span>Total</span>
              <span>${totalAddon.toFixed(2)}</span>
            </div>
          )}
        </div>
      );
      var addCharged = typeof details.totalCharged === 'number' ? details.totalCharged : totalAddon;
      if (addCharged > 0) {
        financialNote = <p style={{margin: '4px 0', fontSize: '14px'}}>Total charged: <strong style={{color: '#e8512f'}}>${addCharged.toFixed(2)}</strong></p>;
      } else {
        financialNote = <p style={{margin: '4px 0', fontSize: '14px', color: '#666'}}>No additional charges.</p>;
      }
    } else if (action === 'cancelAddon') {
      title = "Seat Selection Removed";
      (details.seats || []).forEach(function(s, i) {
        items.push(
          <p key={i} style={{margin: '0 0 4px', fontSize: '14px'}}>
            Seat <strong>{s}</strong> assignment removed
          </p>
        );
      });
      if (details.credit > 0) {
        financialNote = <p style={{margin: '4px 0', fontSize: '14px'}}><strong style={{color: '#4CAF50'}}>${details.credit.toFixed(2)}</strong> has been added to your credit balance.</p>;
      } else {
        // e.g. the seat was covered by a promotional discount — nothing was collected, so nothing is refunded
        financialNote = <p style={{margin: '4px 0', fontSize: '14px', color: '#666'}}>No refund was due for this seat.</p>;
      }
    }

    return (
      <div className="container editTrip confirmTrip">
        <div className="editTripBox">
          <div style={{background: '#f0faf0', border: '1px solid #4CAF50', borderRadius: '6px', padding: '20px', marginBottom: '15px'}}>
            <h4 style={{color: '#4CAF50', marginTop: 0, marginBottom: '12px'}}>{title}</h4>
            {reservationNumber && (
              <p style={{marginBottom: '14px'}}>Reservation <strong>#{config.formatReservationNumber(reservationNumber)}</strong></p>
            )}
            {details.email && (
              <p style={{marginBottom: '14px'}}>A confirmation email has been sent to <strong>{details.email}</strong>.</p>
            )}
            {items}
            {financialNote && (
              <div style={{marginTop: '12px', paddingTop: '10px', borderTop: '1px solid #c8e6c9'}}>
                {financialNote}
              </div>
            )}
          </div>
          <div style={{textAlign: 'center', marginTop: '20px'}}>
            <Link to={'/edit-trip?reservationNumber=' + (reservationNumber || '')} className="btn btn-blue" style={{marginRight: '10px'}}>Edit Reservation</Link>
            <Link to="/" className="btn btn-blue">Book a Trip</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default SeatActionSuccess;
